import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { ManufacturerResource } from "@exonn/js-sdk";

export const module: Module<ManufacturerResource> = {
  id: ResourceEnum.Manufacturer,
  bigIcon: <i className="icon-20-production" />,
  smallIcon: <i className="icon-15-production" />,
  name: (t: TFunction) => t("moduleName.manufacturers"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
